module.exports = __webpack_public_path__ + "media/images/weleda_logo_2024-ffa94863b591431fbd6c84a46a2f6851.png";